import { MutableRefObject, useCallback, useRef } from 'react';

const useCombineRefs = <T>(
  ...refs
): [(el) => void, MutableRefObject<T | undefined>] => {
  const combinedRef = useRef<T>();

  const refCallback = useCallback(
    (el) => {
      refs.forEach((ref) => {
        if (!ref) return;

        if (typeof ref === 'function') {
          ref(el);
        } else {
          ref.current = el;
        }
      });

      combinedRef.current = el;
    },
    [refs],
  );

  return [refCallback, combinedRef];
};

export default useCombineRefs;
